import { IrisBase } from '@/models/iris/IrisBase'

export interface IQuickControlEnabled {
  'module-QuickControl': boolean
}

export interface IQuickControlSettings {
  current_mode: string
  heading_deadzone: number
  heading_target: string
  last_cycle: number
  last_mode: string
  lookahead: number
}

export interface IQuickControlCurrentCorrection {
  enable: boolean
}


export interface IQuickControlEasyWaypoint {
  lat_target: number
  lon_target: number
  navigation_profile: boolean
  zs: number
  zt: number
  zb: number
  pu: number
  pd: number
  bu: number
  bd: number
  sr: number
  alt: number
}

export interface IQuickControlConfig extends IrisBase {
  EnabledMOD: IQuickControlEnabled
  QuickControl: IQuickControlSettings
  QuickControl_current_correction: IQuickControlCurrentCorrection      
  QuickControl_easywaypoint: IQuickControlEasyWaypoint
}

export const getDefaultQuickControlEasyWaypoint = (): IQuickControlEasyWaypoint => ({
  lat_target: 0,
  lon_target: 0,
  navigation_profile: false,
  zs: 2,
  zt: 2,
  zb: 30,
  pu: 1020,
  pd: -1020,
  bu: 1015,
  bd: -1015,
  sr: 1,
  alt: 30,
})

export const getDefaultQuickControlConfig = (): IQuickControlConfig => ({
  EnabledMOD: { 'module-QuickControl': false },
  QuickControl: {
    current_mode: 'waypoint',
    heading_deadzone: 5,
    heading_target: '',
    last_cycle: 0,
    last_mode: '',
    lookahead: 1,
  },
  QuickControl_current_correction: { enable: false },  
  QuickControl_easywaypoint: getDefaultQuickControlEasyWaypoint(),
})
